
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { getPostBySlug, getAllPosts } from '../../lib/blog';
import useTranslation from 'next-translate/useTranslation';
import FormattedDate from '../../components/FormattedDate';
import Head from 'next/head';
import Image from 'next/image';
export async function getStaticPaths({ locales }) {
    const paths = locales.flatMap((locale) => {
        // Generate paths for ALL posts, not just the first paginated page.
        // getAllPosts defaults to 6 per page, so without this every post
        // beyond the first 6 would 404 (fallback: false).
        const { posts } = getAllPosts(locale, 1, Number.MAX_SAFE_INTEGER);
        return posts.map((post) => ({
            params: { slug: post.slug },
            locale
        }));
    });
    return {
        paths,
        fallback: false
    };
}
async function getStaticProps({ params, locale }) {
    const post = getPostBySlug(params.slug, locale);
    return {
        props: {
            post
        }
    };
}
function BlogPost({ post }) {
    const { t, lang } = useTranslation('common');
    return (<>
            <Head>
                <title>{`${post.title} - CPH Security Wait`}</title>
                <meta name="description" content={post.description}/>
                <script type="application/ld+json" dangerouslySetInnerHTML={{
            __html: JSON.stringify(post.structuredData)
        }}/>
            </Head>
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
                    {/* Main Content */}
                    <div className="lg:col-span-3">
                        <article>
                            <header className="mb-8">
                                <h1 className="text-4xl font-bold mb-4">
                                    {post.title}
                                </h1>
                                <div className="flex items-center text-gray-600 text-sm">
                                    {/* <span>{post.author}</span> */}
                                    {/* <span className="mx-2">-</span> */}
                                    <FormattedDate date={post.date} locale={lang} showTime={false}/>
                                </div>
                            </header>

                            <div className="relative w-full aspect-[16/9] mb-8">
                                <Image src={post.image ||
            '/blog/images/blog-placeholder.jpg'} alt={post.title} fill priority sizes="(max-width: 1024px) 100vw, 75vw" className="object-cover rounded"/>
                            </div>

                            <div className="prose prose-lg max-w-none
                                prose-headings:font-bold 
                                prose-h1:text-3xl prose-h1:mb-4
                                prose-h2:text-2xl prose-h2:mt-8 prose-h2:mb-4
                                prose-p:mb-4 prose-p:leading-relaxed
                                prose-a:text-[var(--secondary)] prose-a:underline
                                prose-ul:my-4 prose-li:my-2
                                prose-img:rounded-lg" dangerouslySetInnerHTML={{
            __html: post.content
        }}/>
                        </article>
                    </div>

                    {/* Table of Contents Sidebar */}
                    <div className="hidden lg:block">
                        <div className="sticky top-8">
                            <h2 className="text-xl font-bold mb-4">
                                {t('table_of_contents')}
                            </h2>
                            <nav className="space-y-2">
                                {post.tableOfContents?.map((item) => (<a key={item.id} href={`#${item.id}`} className={`block text-gray-600 hover:text-gray-900 ${item.level === 2 ? 'ml-4' : ''}`}>
                                        {item.title}
                                    </a>))}
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </>);
}
export default BlogPost;

    async function __Next_Translate__getStaticProps__1a1723ec731__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/blog/[slug]',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a1723ec731__ as getStaticProps }
  